// extracted by mini-css-extract-plugin
module.exports = {"reviewHeader":"mentorSub_reviewHeader__1fGw4"};